import Skeleton from 'react-loading-skeleton';

export function PersonDetailsOffcanvasSkeleton() {
  return (
    <div className="d-flex flex-column align-items-center gap-4 p-3">
      <Skeleton
        baseColor="#e8e8e8c5"
        highlightColor="#bababa96"
        style={{
          height: '96px',
          width: '96px',
          borderRadius: '50%',
          marginTop: '3rem',
        }}
        count={1}
      />
      <Skeleton
        baseColor="#e8e8e8c5"
        highlightColor="#bababa96"
        style={{ height: '1.5rem', width: '172px' }}
        className="mt-2"
        count={3}
      />
      <div className="d-flex mt-3" style={{ gap: '64px' }}>
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '52px', width: '110px' }}
          count={1}
        />
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '52px', width: '110px' }}
          count={1}
        />
      </div>
      <div className="align-self-start d-flex flex-column gap-4 mt-3">
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '32px', width: '196px' }}
          count={1}
        />
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '32px', width: '196px' }}
          count={1}
        />
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '32px', width: '196px' }}
          count={1}
        />
      </div>
      <div className="align-self-start w-100 d-flex flex-column justify-content-center gap-3 mt-3">
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '42px' }}
          count={1}
        />
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '42px' }}
          count={1}
        />
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          style={{ height: '42px' }}
          count={1}
        />
      </div>
    </div>
  );
}
